import React from 'react';
import './Loading.css';

const Loading = () => (
	<div className="blockUI">
		<div className="blockUI blockOverlay" />
		<div className="blockUI blockMsg blockPage">
			Loading...<br /><br />
			<img src={require('../Images/ICN_Loading_Animation.gif')} alt="Loading..." />
		</div>
	</div>
);

export default Loading;
